// "Preview" entry point for any brief: opens the full-page preview shell, which picks the
// renderer for the brief's surface (blog article, social post, video page).
import { Link } from "react-router-dom";
import { contentTypeFor, previewSurface } from "../../../../shared/content-preview";
import { briefPreviewPath } from "./paths";

interface Props {
  brandId: string;
  brief: { id: string; campaign_id: string; surface?: string | null; platform?: string | null };
  className?: string;
}

export function previewLabel(brief: Props["brief"]): string {
  const type = contentTypeFor(previewSurface(brief));
  return type === "blog" ? "Preview as blog post" : type === "video" ? "Preview video page" : "Preview post";
}

export function PreviewButton({ brandId, brief, className }: Props) {
  if (!brief.campaign_id) return null;
  return (
    <Link
      to={briefPreviewPath(brandId, brief.campaign_id, brief.id)}
      className={className ?? "inline-flex min-h-9 items-center rounded-lg border border-slate-300 bg-white px-3 text-sm font-medium text-slate-800 hover:bg-slate-50"}
      data-testid="preview-button"
    >
      {previewLabel(brief)}
    </Link>
  );
}
